import cn from "app/utils/classnames";
import IconCheck from "app/icons/IconCheck";
import IconClose from "app/icons/IconClose";
import IconArrow from "app/icons/IconArrow";
import { WordStatus } from "app/utils/wordStatus";

interface WordCompletionIndicatorProps {
  status: WordStatus;
  className?: string;
  children?: React.ReactNode;
}

export function WordCompletionIndicator(props: WordCompletionIndicatorProps) {
  return (
    <div
      className={cn(
        "w-6 h-6 border border-black rounded-sm font-bold flex justify-center items-center",
        props.className,
        getBgColorClassName(props.status)
      )}
    >
      {getInnerContent(props.status)}
    </div>
  );
}

function getBgColorClassName(status: WordStatus): string {
  switch (status) {
    case WordStatus.UPCOMING:
      return "bg-gray-300";
    case WordStatus.CURRENT:
      return "bg-background";
    case WordStatus.CORRECT:
      return "bg-correct";
    case WordStatus.INCORRECT:
      return "bg-incorrect";
    case WordStatus.PARTIALLY_CORRECT:
      return "bg-partial";
    default:
      return "bg-background";
  }
}

function getInnerContent(status: WordStatus): React.ReactNode {
  switch (status) {
    case WordStatus.CORRECT:
      return <IconCheck width={32} height={32} />;
    case WordStatus.INCORRECT:
    case WordStatus.PARTIALLY_CORRECT:
      return <IconClose width={32} height={32} strokeWidth={2.15} />;
    case WordStatus.UPCOMING:
      // return <IconQuestion width={24} height={24}/>;
      return "";
    case WordStatus.CURRENT:
      return <IconArrow width={32} height={32} rotate={-180} />;
    // return "...";
    // return "";
    default:
      return "";
  }
}
